export const cardName = state => {
  return state.cardName;
};

export const keyPagSeguroDev = state => {
  return state.keyPagSeguroDev;
};

export const keyPagSeguroBetaProd = state => {
  return state.keyPagSeguroBetaProd;
};

export const cardCPF = state => {
  return state.cardCPF;
};

export const cardNumber = state => {
  return state.cardNumber;
};

export const paypalToken = state => {
  return state.paypalToken;
};

export const checkTerms = state => {
  return state.checkTerms;
};

export const optIn = state => {
  return state.optIn;
};

export const cardDate = state => {
  return state.cardDate;
};

export const partialValue = state => {
  return state.partialValue;
};

export const cardCVC = state => {
  return state.cardCVC;
};

export const instalmentAmount = state => {
  return state.instalmentAmount;
};

export const interestAmount = state => {
  return state.interestAmount;
};

export const totalAmount = state => {
  return state.totalAmount;
};

export const interests = state => {
  return state.interests;
};

export const billet = state => {
  return state.billet;
};

export const partialError = state => {
  return state.partialError;
};

export const ame = state => {
  return state.ame;
};

export const pix = state => {
  return state.pix;
};

export const paypal = state => {
  return state.paypal;
};

export const paypalPlus = state => {
  return state.paypalPlus;
};

export const paypalClientId = state => {
  return state.paypalClientId;
};

export const ameOrderStatus = state => {
  return state.ameOrderStatus;
};

export const pixOrderStatus = state => {
  return state.pixOrderStatus;
};

export const paymentData = state => {
  return state.paymentData;
};

export const invoice = state => {
  return state.invoice;
};

export const invoiceSale = state => {
  return state.invoiceSale;
};

export const secure3dsOpen = state => {
  return state.secure3dsOpen;
};
